var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8E6C9",
    d: "M95.143 47.714c0 26.197-21.232 47.429-47.429 47.429C21.517 95.143.286 73.91.286 47.714.286 21.517 21.517.286 47.714.286c26.197 0 47.429 21.231 47.429 47.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "m72.818 25.39-32.18 32.218L27.352 44.36l-6.706 6.707 20 19.953 38.878-38.925-6.707-6.706z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFinished);
export default __webpack_public_path__ + "static/media/status-finished.e86e57abb4695154c5983d264248f4ec.svg";
export { ForwardRef as ReactComponent };